import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestCapacityPlanGeocodingMutationVariables = Types.Exact<{
  input: Types.RequestCapacityPlanGeocodingInput;
}>;


export type RequestCapacityPlanGeocodingMutation = { __typename?: 'Mutation', requestCapacityPlanGeocoding: { __typename?: 'RequestCapacityPlanGeocodingPayload', capacityPlanGeocoding?: { __typename?: 'CapacityPlanGeocoding', requested: number, run: { __typename?: 'CapacityPlanRun', id: any, status: Types.CapacityPlanRunStatus, pendingGeocodes: number, failedGeocodes: number, missingCoordinates: number, geocodeRequestedAt?: any | null } } | null, errors?: Array<{ __typename?: 'CapacityPlanUserError', code: Types.CapacityPlanErrorCode, message: string, runId?: any | null }> | null } };


export const RequestCapacityPlanGeocodingDocument = gql`
    mutation RequestCapacityPlanGeocoding($input: RequestCapacityPlanGeocodingInput!) {
  requestCapacityPlanGeocoding(input: $input) {
    capacityPlanGeocoding {
      requested
      run {
        id
        status
        pendingGeocodes
        failedGeocodes
        missingCoordinates
        geocodeRequestedAt
      }
    }
    errors {
      ... on CapacityPlanUserError {
        code
        message
        runId
      }
    }
  }
}
    `;
export type RequestCapacityPlanGeocodingMutationFn = Apollo.MutationFunction<RequestCapacityPlanGeocodingMutation, RequestCapacityPlanGeocodingMutationVariables>;

/**
 * __useRequestCapacityPlanGeocodingMutation__
 *
 * To run a mutation, you first call `useRequestCapacityPlanGeocodingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCapacityPlanGeocodingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCapacityPlanGeocodingMutation, { data, loading, error }] = useRequestCapacityPlanGeocodingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCapacityPlanGeocodingMutation(baseOptions?: Apollo.MutationHookOptions<RequestCapacityPlanGeocodingMutation, RequestCapacityPlanGeocodingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCapacityPlanGeocodingMutation, RequestCapacityPlanGeocodingMutationVariables>(RequestCapacityPlanGeocodingDocument, options);
      }
export type RequestCapacityPlanGeocodingMutationHookResult = ReturnType<typeof useRequestCapacityPlanGeocodingMutation>;
export type RequestCapacityPlanGeocodingMutationResult = Apollo.MutationResult<RequestCapacityPlanGeocodingMutation>;
export type RequestCapacityPlanGeocodingMutationOptions = Apollo.BaseMutationOptions<RequestCapacityPlanGeocodingMutation, RequestCapacityPlanGeocodingMutationVariables>;